<template>
  <div>
    <b-input
      v-model="searchStr"
      label="Пошук за ПІБ"
      placeholder="Введіть ПІБ людини..."></b-input>

    <v-divider></v-divider>

    <department-item
      v-for="department in departmentTree"
      :key="department.id"
      :department="department">
    </department-item>
  </div>
</template>

<script setup lang="ts">
import { Dialog } from '@/dialog'
import { provide, ref, watch } from 'vue'
import { debounce } from 'lodash'
import { internalDepartmentTreeWithUsersList } from '@/requests/internalDepartment'
import DepartmentItem from './DepartmentItem.vue'
import {
  selectedUsersKey,
  selectedDepartmentsKey,
  existDepartmentIdsKey,
  existUserIdsKey,
  usersToDeleteKey,
} from './injectionKeys'
import {
  documentAcceptanceCreate,
  documentAcceptanceDelete,
} from '@/requests/document'
import { InternalDepartmentTreeItem } from '@/utils/types/internalDepartment'
import { DocumentAcceptance } from '@/utils/types/document'
defineOptions({
  name: 'DocumentAcceptance',
})

const props = defineProps<{
  dialog: Dialog
}>()

const searchStr = ref<string>('')
const selectedUsers = ref<number[]>([])
const selectedDepartments = ref<number[]>([])
const usersToDelete = ref<number[]>([])

const existDepartmentIds = props.dialog.dialogData.acceptanceList
  .filter((a: any) => a.acceptorTypeId === 2)
  .map((a: any) => a.acceptorId)
const existUserIds = props.dialog.dialogData.acceptanceList
  .filter((a: any) => a.acceptorTypeId === 1)
  .map((a: any) => a.acceptorId)

provide(selectedUsersKey, selectedUsers)
provide(selectedDepartmentsKey, selectedDepartments)
provide(existDepartmentIdsKey, existDepartmentIds)
provide(existUserIdsKey, existUserIds)
provide(usersToDeleteKey, usersToDelete)

const departmentTree = ref<InternalDepartmentTreeItem[]>([])

const getDepartmentTree = (search: any = null) => {
  return internalDepartmentTreeWithUsersList({ search }).then(res => {
    departmentTree.value = res
  })
}

watch(searchStr, debounce(getDepartmentTree, 500))
getDepartmentTree()

const submit = async () => {
  for (const userId of selectedUsers.value) {
    await documentAcceptanceCreate({
      docTypeDocumentId: props.dialog.dialogData.documentId,
      acceptorId: userId,
      typeId: props.dialog.dialogData.acceptanceTypeId,
      acceptorTypeId: 1,
    })
  }

  for (const departmentId of selectedDepartments.value) {
    await documentAcceptanceCreate({
      docTypeDocumentId: props.dialog.dialogData.documentId,
      acceptorId: departmentId,
      typeId: props.dialog.dialogData.acceptanceTypeId,
      acceptorTypeId: 2,
    })
  }

  for (const userId of usersToDelete.value) {
    for (const acceptance of props.dialog.dialogData
      .acceptanceList as DocumentAcceptance[]) {
      if (acceptance.acceptorTypeId === 1 && acceptance.acceptorId === userId) {
        await documentAcceptanceDelete(acceptance.id)
      }
    }
  }
}

defineExpose({ submit })
</script>
